import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Dialog, Typography } from "@mui/material";
import emailOutlineIcon from "@iconify/icons-mdi/email-outline";
import { InlineIcon } from "@iconify/react";
import { MyHrPublicLayoutLink } from "my-hr/components";
import { OcTransition } from "oc/components";

interface MyHrForgotPasswordEmailSentDialogProps {
  smallScreen: boolean;
}

export const MyHrForgotPasswordEmailSentDialog = ({
  smallScreen,
}: MyHrForgotPasswordEmailSentDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={true}
      scroll={"body"}
      fullScreen={smallScreen}
      TransitionComponent={OcTransition}
      BackdropProps={{
        style: {
          width: "100%",
          backgroundColor: "rgba(0,0,0,0.7)",
          backgroundImage: "url(/img/loginBg.jpg)",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundBlendMode: "darken",
        },
      }}
      sx={{ zIndex: 20000 }}
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        height="inherit"
      >
        <Box width={smallScreen ? "auto" : "400px"} padding="24px">
          <Box textAlign="center" p={0} marginTop="14px">
            <InlineIcon
              icon={emailOutlineIcon}
              width="64px"
              height="64px"
              color="#5E6366"
            />
          </Box>
          <Box textAlign="center" marginTop="30px">
            <Typography variant="h6">{t("MY_HR_TITLE_EMAIL_SENT")}</Typography>
            <Box marginTop="26px" style={{ textAlign: "left" }}>
              <Typography>{t("MY_HR_TEXT_EMAIL_SENT")}</Typography>
            </Box>
          </Box>
          <Box textAlign="center" paddingTop="32px" paddingBottom="6px">
            <MyHrPublicLayoutLink
              label={t("MY_HR_LINK_BACK_TO_LOGIN")}
              path="/"
            />
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default MyHrForgotPasswordEmailSentDialog;
